import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { useMemo } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import UpdateCntrStatusPanel from "../LeftPanel/UpdateCntrStatusPanel";
import UpdateVesselVoyageMasterSearchPanel from "../LeftPanel/UpdateVesselVoyageMasterSearchPanel";
import UpdateVesselVoyageMasterTablePanel from "../LeftPanel/UpdateVesselVoyageMasterTablePanel";
import AssignSeqNoPanel from "./AssignSeqNoPanel";
import ChargeBatchUpdatePanel from "./ChargeBatchUpdatePanel";
import CntrInfoPanel from "./CntrInfoPanel";
import UpdatePaidThroughDatePanel from "./UpdatePaidThroughDatePanel";
import UpdateAgentDeliveryDatePanel from "./UpdateAgentDeliveryDatePanel";
import AssignManualTsLegChargeIndPanel from "./AssignManualTsLegChargeIndPanel";

interface IContentHtml {
    leftWidth: string;
    rightWidth: string;
}

const ChargeDetailMaintenancePanel = () => {
    const [chargeDetailState] = useChargeDetailTracked();
    const { isShowBatchUpdatePanel, isShowRightEditPanel, isShowCntrInfoPanel, isShowUpdateVesselVoyageMasterSearchPanel,
        isShowUpdateVesselVoyageMasterTablePanel, isShowAssignSeqNoPanel, isShowUpdateStatus, isShowPaidThroughDate,
        isShowAgentDeliveryDate, isShowManualTSLegPanel } = chargeDetailState;

    const memoBatchUpdatePanel = useMemo(() => {
        return <ChargeBatchUpdatePanel />
    }, []);

    const memoCntrInfoPanel = useMemo(() => {
        return <CntrInfoPanel />
    }, []);

    const memoUpdateVesselVoyageSearchPanel = useMemo(() => {
        return <UpdateVesselVoyageMasterSearchPanel />
    }, []);

    const memoUpdateVesselVoyageTablePanel = useMemo(() => {
        return <UpdateVesselVoyageMasterTablePanel />
    }, []);

    const memoAssignSeqNoPanel = useMemo(() => {
        return <AssignSeqNoPanel />
    }, []);

    const memoUpdateCntrStatusPanel = useMemo(() => {
        return <UpdateCntrStatusPanel />
    }, []);

    const memoUpdatePaidThroughDatePanel = useMemo(() => {
        return <UpdatePaidThroughDatePanel />
    }, []);

    const memoUpdateAgentDeliveryDatePanel = useMemo(() => {
        return <UpdateAgentDeliveryDatePanel />
    }, []);

    const memoAssignManualTsLegIndPanel = useMemo(() => {
        return <AssignManualTsLegChargeIndPanel />
    }, []);

    const getSliderContent = (): IContentHtml => {
        if (isShowBatchUpdatePanel || isShowCntrInfoPanel || isShowUpdateVesselVoyageMasterTablePanel || isShowAssignSeqNoPanel
            || isShowPaidThroughDate || isShowAgentDeliveryDate || isShowManualTSLegPanel) {
            return { leftWidth: '0%', rightWidth: '100%' };
        } else if ((isShowRightEditPanel || isShowUpdateVesselVoyageMasterSearchPanel)) {
            return { leftWidth: '100%', rightWidth: '0%' };
        } else {
            return { leftWidth: '100%', rightWidth: '0%' };
        }
    }

    const content: IContentHtml = getSliderContent();

    let memoRightChild = <></>;
    if (isShowBatchUpdatePanel) {
        memoRightChild = memoBatchUpdatePanel;
    } else if (isShowCntrInfoPanel) {
        memoRightChild = memoCntrInfoPanel;
    } else if (isShowUpdateVesselVoyageMasterTablePanel) {
        memoRightChild = memoUpdateVesselVoyageTablePanel;
    } else if (isShowAssignSeqNoPanel) {
        memoRightChild = memoAssignSeqNoPanel;
    } else if (isShowPaidThroughDate) {
        memoRightChild = memoUpdatePaidThroughDatePanel;
    } else if (isShowAgentDeliveryDate) {
        memoRightChild = memoUpdateAgentDeliveryDatePanel;
    } else if (isShowManualTSLegPanel) {
        memoRightChild = memoAssignManualTsLegIndPanel;
    }

    return <div className={`main-comp-wrapper${isShowUpdateVesselVoyageMasterSearchPanel || isShowUpdateStatus ? '' : ' im-hide-side-form-draggable'}`}>
        <SliderPanel
            isOpen={true}
            leftSectionWidth={content.leftWidth}
            rightSectionWidth={content.rightWidth}
            draggable={false}
            leftChildren={isShowUpdateVesselVoyageMasterSearchPanel ? memoUpdateVesselVoyageSearchPanel :
                (isShowUpdateStatus ? memoUpdateCntrStatusPanel : <></>)}
            rightChildren={memoRightChild}
        />
    </div>
}

export default ChargeDetailMaintenancePanel;